import Contact from "../components/Contact";

const ContactInterface = () => {
  return (
    <>
      <Contact />
      
    </>
  );
};
export default ContactInterface;
